module.exports = __webpack_public_path__ + "static/media/toggle_on_white_24dp.627f5e89.svg";